import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import I18n from '../../config/i18n';

import { actions } from './actions';

/* ------------- Categories reducer ------------- */
const defaultState = {
  loaded: false,
  loading: false,
  list: null,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.LOAD_START: {
      return state.merge({ loaded: false, loading: true, list: null });
    }
    case actions.LOAD_SUCCESS: {
      const list = action.payload.list.map(category => ({
        value: category.id,
        label: I18n.t(`category.${category.key}.name`),
      }));
      return state.merge({ list, loaded: true, loading: false });
    }
    case action.LOAD_FAIL: {
      return state.merge({ loaded: true, loading: false, list: [] });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

/* ------------- Auth propTypes ------------- */
export const propTypes = {
};



// WEBPACK FOOTER //
// ./src/redux/Categories/reducer.js